module.exports = __webpack_public_path__ + "img/refer.3250cf0b.svg";